import React from "react";
import { RouteObject } from "helpers/tixxt-router";
import MobileAppChat from "./MobileAppChat";

const membershipRoutes: RouteObject[] = [
  { path: "/chat", element: <MobileAppChat /> },
];

export default membershipRoutes;
